(function ($) {
	'use strict';

	var cfg = window.dfdFddLead || {};
	var i18n = cfg.i18n || {};

	function modal() {
		return document.getElementById('fdd-lead-modal');
	}

	function openModal(opts) {
		var el = modal();
		if (!el) {
			return;
		}
		opts = opts || {};
		el.querySelector('.fdd-lead-modal-title').textContent = i18n.title || '';
		el.querySelector('.fdd-lead-modal-copy').textContent = i18n.copy || '';
		el.querySelector('[data-fdd-lead-email-label]').textContent = i18n.emailLabel || '';
		el.querySelector('[data-fdd-lead-submit]').textContent = i18n.submit || '';
		el.querySelector('[data-fdd-lead-franchise]').value = opts.franchiseId || '';
		el.querySelector('[data-fdd-lead-doc-title]').value = opts.docTitle || '';
		el.querySelector('[data-fdd-lead-email]').value = '';
		var msg = el.querySelector('[data-fdd-lead-message]');
		msg.hidden = true;
		msg.textContent = '';
		msg.classList.remove('is-error', 'is-success');
		el.hidden = false;
		document.documentElement.classList.add('fdd-lead-open');
		window.setTimeout(function () {
			el.querySelector('[data-fdd-lead-email]').focus();
		}, 10);
	}

	function closeModal() {
		var el = modal();
		if (!el) {
			return;
		}
		el.hidden = true;
		document.documentElement.classList.remove('fdd-lead-open');
	}

	$(document).on('click', '[data-fdd-lead-open]', function (e) {
		e.preventDefault();
		var $btn = $(this);
		openModal({
			franchiseId: $btn.attr('data-franchise-id') || '',
			docTitle: $btn.attr('data-document-title') || '',
		});
	});

	$(document).on('click', '[data-fdd-lead-close]', function (e) {
		e.preventDefault();
		closeModal();
	});

	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && modal() && !modal().hidden) {
			closeModal();
		}
	});

	$(document).on('submit', '[data-fdd-lead-form]', function (e) {
		e.preventDefault();
		var form = e.currentTarget;
		var email = (form.querySelector('[data-fdd-lead-email]').value || '').trim();
		var $msg = $(form).find('[data-fdd-lead-message]');
		var $submit = $(form).find('[data-fdd-lead-submit]');

		if (!email || email.indexOf('@') < 1) {
			$msg
				.text(i18n.invalid || 'Please enter a valid email address.')
				.addClass('is-error')
				.removeClass('is-success')
				.prop('hidden', false);
			return;
		}

		$submit.prop('disabled', true).text(i18n.sending || 'Sending…');
		$msg.prop('hidden', true);

		$.ajax({
			url: cfg.ajaxUrl || '/wp-admin/admin-ajax.php',
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'dfd_fdd_lead',
				nonce: cfg.nonce || '',
				email: email,
				franchise_id: form.querySelector('[data-fdd-lead-franchise]').value || '',
				document_title: form.querySelector('[data-fdd-lead-doc-title]').value || '',
			},
		})
			.done(function (res) {
				var ok = res && res.success;
				var text = ok
					? (res.data && res.data.message) || i18n.success
					: (res && res.data && res.data.message) || i18n.error;
				$msg
					.text(text || '')
					.toggleClass('is-success', !!ok)
					.toggleClass('is-error', !ok)
					.prop('hidden', false);
				if (ok) {
					form.querySelector('[data-fdd-lead-email]').value = '';
				}
			})
			.fail(function () {
				$msg
					.text(i18n.error || 'Something went wrong.')
					.addClass('is-error')
					.removeClass('is-success')
					.prop('hidden', false);
			})
			.always(function () {
				$submit.prop('disabled', false).text(i18n.submit || 'Send me the FDD');
			});
	});
})(jQuery);
